<template>
  <v-main>
    <AppBar hide-back />
    <!-- 만족도 검사후 코인모달 -->
    <v-layout fill-height column>
      <v-container flex-fill class="pb-0">
        <div class="fs-24 fw-600 line-height-2 mb-2">
          함께한 가이드는<br>
          어떠셨나요?
        </div>
        <p class="fs-14 fw-300 secondary--text mb-15">평가해주시면 앞으로의 여행이 더욱 업그레이드될 거에요!</p>
        <div class="text-center mb-10">
          <v-rating
              v-model="rating"
              size="36"
              ></v-rating>
          </div>
        <template v-if="rating !== 0">
          <div class="blueGrayDarken4--text mb-4">
            별점 <strong class="primary--text">{{rating}}</strong>점을 주셨네요.<br>
            이유를 1개 이상 선택해주세요.
          </div>
          <!-- <v-btn block class="mb-3 feedback">하루하루 추천해준 미션이 정말 좋았어요.</v-btn> -->
          <v-list class="feedback-list">
            <v-list-item-group
                v-model="feedback"
                multiple
            >
              <v-list-item
                  v-for="(feedbackItem, i) in feedbackItems[rating]"
                  :key="i"
                  :ripple="false"
              >
                <v-list-item-content>
                  <div v-html="feedbackItem"></div>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
          <div v-if="(rating !== 0 && comment === '')" class="rounded grayBG px-4 py-3 moreWrite" @click="moreWrite">
            <div class="fs-11" v-if="clientCd != 'samsungfire'">입력 시, 추가 코인을 드려요~</div>
            <div class="fs-14">더 하고 싶은 말이 있어요!</div>
          </div>
          <div v-if="(rating !== 0 && comment !== '')" class="rounded grayBG px-4 py-3 moreWrite" @click="moreWrite">
            <div class="fs-11">작성완료</div>
            <div class="fs-14">{{ comment }}</div>
          </div>
        </template>
      </v-container>
      <div class="footer-btns">
        <BlackBtn x-large str="확인" @click="next" :disabled="rating === 0 || feedback.length === 0" />
      </div>
          <!-- 더 하고싶은 말 -->
          <GuideEvaluationSheet :sheet="sheet" @sheetClose="sheetClose" @writeComplete="writeComplete"/>
    </v-layout>
  </v-main>
</template>
<script>
import store from '@/store'
import { mixinReward } from '@/mixins'
import BlackBtn from "@/components/btns/BlackBtn";
import GuideEvaluationSheet from "@/components/layout/bottomSheet/GuideEvaluationSheet";

export default {
  components: {
    BlackBtn,
    GuideEvaluationSheet,
  },
  mixins: [ mixinReward ],
  data: () => ({
    rating: 0,
    sheet: false,
    dialog: false,
    comment: '',
    feedbackItems: {
      1: [
        '하루하루 추천해준 <strong class="highlight">미션</strong>이 실망스러웠습니다.',
        '미션에 대한 <strong class="highlight">피드백</strong> 내용이 실망스러웠습니다.',
        '함께한 <strong class="highlight">찐한 대화</strong>가 실망스러웠습니다.',
      ],
      2: [
        '하루하루 추천해준 <strong class="highlight">미션</strong>이 기대에 못 미쳤어요.',
        '미션에 대한 <strong class="highlight">피드백</strong> 내용이 기대에 못 미쳤어요.',
        '함께한 <strong class="highlight">찐한 대화</strong>가 기대에 못 미쳤어요.',
      ],
      3: [
        '하루하루 추천해준 <strong class="highlight">미션</strong>이 그저 그랬어요.',
        '미션에 대한 <strong class="highlight">피드백</strong> 내용이 그저 그랬어요.',
        '함께한 <strong class="highlight">찐한 대화</strong>가 그저 그랬어요.',
      ],
      4: [
        '하루하루 추천해준 <strong class="highlight">미션</strong>이 좋았어요.',
        '미션에 대한 <strong class="highlight">피드백</strong> 내용이 좋았어요.',
        '함께한 <strong class="highlight">찐한 대화</strong>가 좋았어요.',
      ],
      5: [
        '하루하루 추천해준 <strong class="highlight">미션</strong>이 정말 좋았어요.',
        '미션에 대한 <strong class="highlight">피드백</strong> 내용이 정말 좋았어요.',
        '함께한 <strong class="highlight">찐한 대화</strong>가 정말 좋았어요.',
        ],
      },
    feedback: [],
    clientCd: '',
  }),
  created() {
    this.clientCd = store.getters.clientCd
    if (store.getters.guideEvalYn == 'Y') {
      this.movePage('/');
    }
    if (this.$route.params.ordDtlNo == null || this.$route.params.ordDtlNo == '' || this.$route.params.ordDtlNo == undefined) {
      this.movePage('/')
    }
  },
  methods: {
    sheetClose() {
      this.sheet = false;
    },
    moreWrite() {
      this.sheet = true;
    },
    writeComplete(comment) {
      this.comment = comment;
      this.sheet = false;
    },
    async next() {
      this.saveGuideEval()
    },
    modalClose() {
      this.dialog = false;
    },
    async saveGuideEval() {
      let params = {
        starPoint: this.rating,
        evalList: this.feedback,
        comment: this.comment,
        ordDtlNo: this.$route.params.ordDtlNo
      }
      await store.dispatch('setGuideEval', this.$_payload('po', params))
          .then(res => {
            if (res.success) {
              this.insertMemberCoin(this.$store.state.auth.authUser.userKey, 10, '0004')
              // this.$root.$children[0].$refs.content.$emit('insertMemberCoin',this.$store.state.auth.authUser.userKey, 10, '0004')
              if(this.comment !== ''){ // 더하고싶은말 입력시 추가 코인
                this.insertMemberCoin(this.$store.state.auth.authUser.userKey, 10, '0005')
                // this.$root.$children[0].$refs.content.$emit('insertMemberCoin',this.$store.state.auth.authUser.userKey, 10, '0005')
              }
            } else {
              console.log(res.msg);
            }
          })
          .catch(error => {
            console.error(error)
          })
          .finally(() => {
            store.dispatch('getUserSltCmplt')
            setTimeout(() => this.movePage('/'), 500);
          })
    },
  }
}
</script>
<style lang="scss" scoped>
::v-deep.feedback-list {
  color: #212529;

  .v-list-item {
    border-radius: 6px;
    box-shadow: 0px 3px 6px #00000029;
    margin-bottom: 12px;
    border: 1px solid #fff;
    transition: all 0.05s ease-out;

    &:before {
      opacity: 0 !important;
    }

    .v-list-item__content {
      padding: 24px 0;
    }

    &.v-item--active {
      border: 1px solid $color-main;
      box-shadow: none;

      &:before {
        opacity: 0 !important;
      }
    }
  }

  .highlight {
    display: inline-block;
    position: relative;
    z-index: 1;

    &:after {
      position: absolute;
      display: inline-block;
      content: '';
      width: 100%;
      height: 10px;
      background: rgba(114, 96, 255, .46);
      z-index: -1;
      bottom: 0;
      left: 0;
    }
  }

}

.moreWrite {
  cursor: pointer;
  background: url('~@/assets/images/ic_arrow_right4.svg') right 7px center no-repeat;
  background-size: auto 14px;
  .fs-11 {
    color: #919191;
  }

  .fs-14 {
    color: #3B3B3B;
  }
}
</style>
